import { useState } from 'react'

import { ApartmentDeadline, IdentifiableObject } from '../models'
import { axiosInstance } from '../helpers'

export const useEZFolioDeadlines = () => {
    const [deadlines, setDeadlines] = useState<ApartmentDeadlineData[]>([])
    const [loading, setLoading] = useState(false)

    const getApartmentDeadlineData = async (
        organizationId: number,
        startDate?: string,
        endDate?: string,
    ) => {
        try {
            setLoading(true)
            const params: {
                organization: number
                start_date?: string
                end_date?: string
            } = {
                organization: organizationId,
            }

            if (startDate) {
                params.start_date = startDate
            }
            if (endDate) {
                params.end_date = endDate
            }

            const response = await axiosInstance.get(
                'deadline/ezfolio-deadline-list/',
                {
                    params,
                },
            )
            setLoading(false)
            const deadlineData: ApartmentDeadlineData[] = response.data
            setDeadlines(deadlineData)
            return deadlineData
        } catch (error) {
            console.error('Error getting apartment deadline data:', error)
            setLoading(false)
            return Promise.reject(error)
        }
    }

    return { deadlines, loading, getApartmentDeadlineData }
}

export interface ApartmentDeadlineData extends IdentifiableObject {
    name: string
    total_deadlines: number
    total_deadlines_completed: number
    total_deadlines_overdue: number
    deadlines: ApartmentDeadline[]
}
